<template>
  <div class="donation">
    <PageBanner />
    <Breadcrumbs />

    <section class="content">
      <div class="container">
        <h2 class="h4">百家講談</h2>
        <p>「百家講談」走遍香港，約訪不同專家、 學者，力求以通俗易懂的形式將各種知識傳播於社會之中。攜手共建共享教育。</p>
        <div
          class="row"
          id="videos"
        >
          <videoItem
            :path="video.path"
            :cover="video.cover"
            :title="video.title"
            :position="index+1"
            v-for="(video,index) in videos"
            :key="index"
          >
          </videoItem>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  import PageBanner from "@/components/pageBanner.vue";
  import Breadcrumbs from "@/components/breadcrumbs.vue";
  import VideoItem from "@/components/videoItem.vue";
  import videoData from "@/assets/data/video.json";
  export default {
    name: "",
    components: {
      PageBanner,
      Breadcrumbs,
      VideoItem
    },
    data() {
      return {
        videos: videoData.hundred_talk
      };
    },
    mounted: function mounted() {
      $(".portfolio-popup").magnificPopup({
        type: "iframe",
        removalDelay: 300,
        mainClass: "mfp-fade",
        gallery: {
          enabled: true
        },
        zoom: {
          enabled: true,
          duration: 300,
          easing: "ease-in-out",
          opener: function(openerElement) {
            return openerElement.is("img")
              ? openerElement
              : openerElement.find("img");
          }
        }
      });
    }
  };
</script>